export enum PipelineStatus {
  PUBLISHED = 'Publicada',
  UNPUBLISHED = 'Despublicada',
}

export class Catalog {
  id!: string;
  name!: string;
  pipeline_id!: string;
  tasks_count!: number;
  status!: PipelineStatus;
  updated_at!: string;
  updated_by!: string;
  hasPermission!: boolean;

  constructor(pipeline: Partial<Catalog | null>) {
    this.id = '';
    this.name = '';
    this.pipeline_id = '';
    this.tasks_count = 0;
    this.status = PipelineStatus.UNPUBLISHED;
    this.hasPermission = true;
    Object.assign(this, pipeline);
  }
}